import React from 'react';
import './TabComponent.scss';

const ComponentTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="tabs-container">
      <div className="tab-headers">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${index === activeTab ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab-panel ${index === activeTab ? 'active' : 'inactive'}`}
            style={{ display: index === activeTab ? 'block' : 'none' }}
            >
            {
              // If content is a function, call it to get updated UI
              typeof tab.content === 'function'
                ? tab.content()
                : tab.content
            }
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComponentTabs;
